module.exports = __webpack_public_path__ + "img/10b-analises-atendimento-acoes.f77edb91.png";